import { Link } from 'react-router-dom';
import PrivacyPolicyBody from '../components/PrivacyPolicyBody';

export default function Privacy() {
  return (
    <div className="page">
      <header className="site-header shell">
        <Link to="/" className="logo" style={{ textDecoration: 'none', color: 'inherit' }}>
          JAMTICK
        </Link>
      </header>

      <div className="checkout-wrap">
        <h1>นโยบายความเป็นส่วนตัว / PRIVACY POLICY</h1>

        <div className="card" style={{ lineHeight: 1.8, fontSize: 14 }}>
          <PrivacyPolicyBody />
        </div>

        <Link to="/" className="btn-link" style={{ display: 'inline-block', marginTop: 8 }}>
          ← กลับหน้าหลัก
        </Link>
      </div>
    </div>
  );
}
